var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0C8.74781 0 0 8.74781 0 19.5C0 30.2522 8.74781 39 19.5 39C30.2522 39 39 30.2522 39 19.5C39 8.74781 30.2522 0 19.5 0ZM19.6875 9C21.0225 9 22.3276 9.39588 23.4376 10.1376C24.5476 10.8793 25.4128 11.9335 25.9237 13.1669C26.4346 14.4003 26.5683 15.7575 26.3078 17.0669C26.0474 18.3762 25.4045 19.579 24.4605 20.523C23.5165 21.467 22.3137 22.1099 21.0044 22.3703C19.695 22.6308 18.3378 22.4971 17.1044 21.9862C15.871 21.4753 14.8168 20.6101 14.0751 19.5001C13.3334 18.3901 12.9375 17.085 12.9375 15.75C12.9375 13.9598 13.6487 12.2429 14.9145 10.977C16.1804 9.71116 17.8973 9 19.6875 9ZM19.5 36C17.2242 36.0009 14.9729 35.5299 12.8884 34.6165C10.8039 33.7032 8.93144 32.3675 7.38937 30.6937C8.21813 26.4019 15.6619 25.5 19.5 25.5C23.3381 25.5 30.7819 26.4019 31.6106 30.6928C30.0688 32.3669 28.1964 33.7029 26.1118 34.6164C24.0273 35.5299 21.7759 36.001 19.5 36Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoUser);
export default __webpack_public_path__ + "static/media/photo-user.365c5e43413dacde64e4e5ada6a391c7.svg";
export { ForwardRef as ReactComponent };